import React, { useState, useEffect } from "react";
import Clock from "../../common/assests/clock.svg";
import More from "../../common/assests/more.svg";
import Message from "../../common/assests/message.svg";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import FavoriteIcon from "@mui/icons-material/Favorite";
import {
  Box,
  Dialog,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  allUserCommentsDataApi,
  allUserPostListApi,
  postDeleteApi,
} from "../../api";
import { useParams } from "react-router-dom";
import Loader from "../../common/loader/Loader";
import Paginations from "../../common/pagination/Paginations";
import ReyLeaf from "../../common/assests/reyleafLogo.svg";
import UserAvatar from "../../common/avatar/UserAvatar";
import { toast } from "react-toastify";
import { useConfirm } from "../../common/confirmDialog/useConfirm";
import { formatCount } from "../../utils/formatCount";
import CustomModal from "../../common/customModal/CustomModal";
import CrossIcon from "../../common/assests/croosicon.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CommentModal from "../../common/customModal/CommentModal";
import configuration from "../../config/Config";

const AllPost = () => {
  const { id } = useParams();
  const token = useSelector((state) => state?.user?.user?.token);
  const confirm = useConfirm();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allPostList, setALLPostList] = useState([]);

  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [change, setChange] = useState(false);

  const [postId, setPostId] = useState(null);
  const [commentData, setCommentData] = useState([]);
  const [commentCurrentPage, setCommentCurrentPage] = useState(1);
  const [commentTotalPages, setCommentTotalPages] = useState(1);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e, id) => {
    setPostId(id);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModalOepn = (item) => {
    // console.log("itm",item);
    setPostId(item?._id);
    handleCommentDetails(item?._id);
    setOpenModal(true);
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleAllPostList = async () => {
    try {
      setLoading(true);
      const response = await allUserPostListApi({ token, currentPage, id: id });
      setALLPostList(response?.posts || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDeletePost = async (id) => {
    const isConfirmed = await confirm({
      title: "Delete Post",
      description: "Are you sure you want to delete this post?",
      confirmText: "Delete",
      destructive: true,
    });
    if (!isConfirmed) return;
    try {
      const response = await postDeleteApi({ token, id: id });
      setChange(!change);
      toast.success(response.message);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error || error?.message);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleAllPostList();
  }, [currentPage, change]);

  const handleCommentDetails = async (id) => {
    try {
      const response = await allUserCommentsDataApi({
        token,
        id, // Post ID
        commentCurrentPage,
      });

      setCommentData((prev) => [...prev, ...(response?.comment || [])]);
      setCommentTotalPages(response?.totalPages || 1);
      setCommentCurrentPage(response?.currentPage || 1);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error || error?.message);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (postId) {
      handleCommentDetails(postId);
    }
  }, [commentCurrentPage]);

  const loadMoreTickets = () => {
    if (commentCurrentPage < commentTotalPages) {
      setCommentCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const hasMoreTickets = commentCurrentPage < commentTotalPages;

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>
      {loading ? (
        <Loader variant="grid" />
      ) : (
        <>
          <Typography
            sx={{
              color: "#362B24",
              fontFamily: "Heebo",
              fontWeight: "600",
              marginTop: "40px",
              fontSize: { xs: "4vw", sm: "3vw", md: "1.5vw", lg: "22px" },
              paddingLeft: "10px",
            }}
          >
            All User Post
          </Typography>

          <Grid container spacing={2}>
            {allPostList?.length > 0 ? (
              allPostList.map((item) => (
                <Grid item xs={12} sm={6} md={4} key={item?._id}>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "449px",
                      height: "auto",
                      flexShrink: 0,
                      borderRadius: "22px",
                      backgroundColor: "#FFF",
                      boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                      display: "flex",
                      flexDirection: "column",
                      padding: "16px",
                      marginTop: "25px",
                      // overflow:'hidden',
                      marginBottom: "30px",
                    }}
                  >
                    {/* First Row: Image and Text */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        marginBottom: "10px",
                      }}
                    >
                      <UserAvatar
                        src={
                          item?.user?.picture
                            ? `${configuration.cdnFront}/${item.user.picture}`
                            : undefined
                        }
                        name={item?.user?.fullname}
                        size={45}
                        sx={{ mr: "12px", flexShrink: 0, borderRadius: "13px" }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: "#362B24",
                          }}
                        >
                          {item?.user?.fullname || ""}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#065F46",
                            fontWeight: "400",
                            marginTop: "5px",
                          }}
                        >
                          <img
                            src={Clock}
                            className="me-2"
                            style={{ fontFamily: "Heebo" }}
                          />
                          {item?.updated_at
                            ? new Date(item.updated_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    {item?.photos?.length > 0 && (
                      <Typography
                        sx={{
                          display: "flex",
                          gap: "20px",
                          borderRadius: "17px",
                          mt: "8px",
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                      >
                        {item?.photos?.length === 1 ? (
                          <img
                            src={
                              item.photos[0]?.url
                                ? `${configuration.cdnFront}/${item.photos[0]?.url}`
                                : ReyLeaf
                            }
                            style={{
                              width: "100%",
                              height: "248px",
                              borderRadius: "17px",
                            }}
                            alt="Single"
                          />
                        ) : (
                          <Swiper
                            spaceBetween={10}
                            slidesPerView={1.4}
                            loop={true}
                            breakpoints={{
                              320: {
                                slidesPerView: 1,
                              },

                              640: {
                                slidesPerView: 0,
                              },
                              768: {
                                slidesPerView: 1.2,
                              },
                              1024: {
                                slidesPerView: 0.8,
                              },
                              1200: {
                                slidesPerView: 1,

                                spacing: 20,
                              },
                              1400: {
                                slidesPerView: 1.4,
                              },
                            }}
                          >
                            {item?.photos?.map((photo, indx) => (
                              <SwiperSlide key={indx}>
                                <img
                                  src={
                                    photo?.url
                                      ? `${configuration.cdnFront}/${photo?.url}`
                                      : ReyLeaf
                                  }
                                  style={{
                                    width: "100%",
                                    height: "248px",
                                    borderRadius: "17px",
                                  }}
                                  alt={`slide-${indx}`}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        )}
                      </Typography>
                    )}

                    {/* Second Row: Description */}
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#362B24",
                        marginBottom: "10px",
                        opacity: 0.6,
                        fontFamily: "Heebo",
                        mt: "10px",
                        lineHeight: "20px",
                        maxWidth: "290px",
                        width: "100%",
                      }}
                    >
                      {item?.description || "N/A"}
                    </Typography>

                    <Box
                      sx={{
                        fontSize: "12px",
                        color: "#362B24",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // marginBottom:'30px'
                      }}
                    >
                      <Typography
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1,
                          fontFamily: "Heebo",
                          fontWeight: 400,
                          fontSize: "14px",
                        }}
                      >
                        <FavoriteIcon sx={{ color: "red" }} />
                        <span>{formatCount(item?.likeCount)} Likes</span>
                        <Typography
                          onClick={() => handleModalOepn(item)}
                          sx={{
                            marginLeft: { xs: "0px", xl: "20px" },
                            fontSize: "14px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 1,
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={Message}
                            alt="Message"
                            style={{ width: "23px", height: "23px" }}
                          />
                          <span>
                            {formatCount(item?.commentCount)} Comments
                          </span>
                        </Typography>
                      </Typography>

                      <Box sx={{ position: "relative" }}>
                        <Typography
                          onClick={(e) => handleClick(e, item?._id)}
                          sx={{ cursor: "pointer" }}
                          className="more-btn"
                        >
                          <img
                            src={More}
                            alt="More"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </Typography>

                        {/* Conditional Box */}

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          sx={{
                            "& .MuiPaper-root": {
                              color: "#EA001B",
                              fontSize: "13px",
                              fontWeight: "500",
                              fontFamily: "Heebo",
                              cursor: "pointer",
                              width: "97px",
                              height: "55px",
                              flexShrink: 0,
                              borderRadius: "12px 0px 12px 12px",
                              backgroundColor: "#FFF",
                              boxShadow: "1px 2px 16px 0px rgba(0, 0, 0, 0.10)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              handleDeletePost(postId); // Use the stored post ID
                              handleClose(); // Close the menu after action
                            }}
                            sx={{
                              fontFamily: "Heebo",
                              color: "#EA1D26",
                              fontWeight: "400",
                            }}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))
            ) : (
              <div style={{ margin: "auto" }}>No Data Found</div>
            )}
          </Grid>

          {/* modal */}

          <CommentModal
            open={openModal}
            onClose={handleModalClose}
            data={commentData}
            loadMore={loadMoreTickets}
            hasMore={hasMoreTickets}
          />

          {/* pagianation */}

          <div style={{ marginBottom: "20px" }}>
            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              disabled={loading}
              onPageChange={handlePageChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AllPost;
